import { EndpointGroup } from 'modules/endpoints/types';

import { getConsensusGroup } from './getConsensusGroup';

export interface EndpointsGroupParams {
  group: EndpointGroup;
  isConsensusEnabled?: boolean;
}

export const getEndpointsGroup = ({
  group,
  isConsensusEnabled,
}: EndpointsGroupParams) => {
  if (!isConsensusEnabled) {
    return group;
  }

  return getConsensusGroup(group) || group;
};
